// GENERATED CODE - DO NOT MODIFY BY HAND

import * as m from '@april9au/stack9-sdk';
import { z } from 'zod';

import { OrganisationGroup } from './OrganisationGroup';

export const Organisation = z.object({
  name: m.ZTextField,
  is_active: m.ZCheckbox.optional().nullable(),
  ranking: m.ZNumericField.optional().nullable(),
  thumbnail: m.ZFileField.optional().nullable(),
  welcome_message: m.ZTextField.optional().nullable(),
});
export type Organisation = z.infer<typeof Organisation>;

export const OrganisationWithRelated = Organisation.extend({
  organisation_groups: z.array(OrganisationGroup),
});
export type OrganisationWithRelated = z.infer<typeof OrganisationWithRelated>;

export const DBOrganisation = m.ZEntityInterface.merge(Organisation);
export type DBOrganisation = z.infer<typeof DBOrganisation>;
